import { useEffect } from "react"

export default function ScrollToHash() {
    useEffect(() => {
        const hash = window?.location.hash
        if (hash) {
            setTimeout(() => {
                const elementId = hash.slice(1)
                const element = document.getElementById(elementId)
                if (element) {
                    const menuBottomY = document.getElementsByClassName("menubar")[0]?.getBoundingClientRect().bottom
                        ? document.getElementsByClassName("menubar")[0].getBoundingClientRect().bottom
                        : 0
                    const yOffset = -menuBottomY - 80
                    const y = element.getBoundingClientRect().top + window.scrollY + yOffset
                    window.scrollTo({ top: y, behavior: "smooth" })
                }
            }, 700)
        }
    }, [])
    return null
}
